export default __webpack_public_path__ + "assets/img/megafon.ad883a9.svg";